import { Injectable, ErrorHandler, inject } from '@angular/core';
import { AppInsightsLoggerService } from './app-insights-logger.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  private readonly _appInsightsLoggerService = inject(AppInsightsLoggerService);

  handleError(error: Error) {
    this._appInsightsLoggerService.logException(error); // Manually log exception
    throw error;
  }
}
